import { bdTrackerAllowedRoles } from 'data/bdTracker/bdTrackerUserRoleValidations';
import { Source, User } from 'Interfaces/BDPortalInterfaces';
import { observer } from 'mobx-react';
import { Avatar } from 'primereact/avatar';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';
import { getBackgroundColor } from 'utils/avatarUtilities';
import { getStatus } from 'utils/bdTrackerUtilities/checkStageUtility';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { getInitials } from 'utils/getInitials';
import EditOpportunity from '../EditOpportunity/EditOpportunity';
import OpportunityFilter from '../OpportunityFilter/OpportunityFilter';
import styles from './OpportunitKanbanLIst.module.scss';
import OpportunityKanbanListLogic from './OpportunityKanbanList.logic';

const MultiKanbanList: React.FC = () => {
  const {
    userModulesRoles,
    isDropDownDetailsAndOppLoading,
    boardDetails,
    handleSetItertation,
    iteration,
    opportunityIID,
    isEditOpportunityModalOpen,
    closeEditOpportunityModal,
    board,
    allOpportunityDetails,
    handleCardClick,
    quickLoadCards,
    handleDropdownChange,
    quickLoad,
    opportunityID,
    filterOpportunityIterationsForTheappliedFilters,
    handleListButtonClick,
  } = OpportunityKanbanListLogic();

  const assigneeOptionTemplate = (option: User | null) => {
    return (
      <>
        {option ? (
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <div style={{ width: '3rem', height: '100%' }}>
              <Avatar
                title={option.Name}
                id="profileAvatar"
                shape="circle"
                label={option.Name && getInitials(option?.Name)}
                style={{
                  backgroundColor: getBackgroundColor(option.Name[0]),
                  color: '#522D6E',
                  marginRight: '0.5rem',
                }}
              />
            </div>
            <div>{option.Name}</div>
          </div>
        ) : (
          <span>Unassigned</span>
        )}
      </>
    );
  };
  return (
    <>
      <OpportunityFilter
        boardType={iteration}
        setBoardType={handleSetItertation}
        viewType={'List'}
        handleListClick={handleListButtonClick}
      />
      {!isDropDownDetailsAndOppLoading ? (
        <div className={styles.listView} style={{ padding: 'rem' }}>
          <div className={styles.listViewHeader}>
            <h4>OID</h4>
            <h4>MOLECULE NAME</h4>
            <h4>SOURCE</h4>
            <h4>STAGE</h4>
            <h4>STATUS</h4>
            <h4>ANALYSTS</h4>
          </div>
          {(board === 'NC' || board === 'MAS') &&
            filterOpportunityIterationsForTheappliedFilters(allOpportunityDetails).map(
              opportunity => {
                const source = boardDetails?.[board]?.Source?.find(
                  (src: Source) => src.ID === opportunity.SourceID
                )?.Source;
                // const isLoadingCard = quickLoadCards.has(opportunity.OpportunityIterationsID);
                return (
                  <div
                    key={opportunity.OpportunityIterationsID}
                    className={styles.listCard}
                    style={{ width: '100%', position: 'relative' }}
                  >
                    {quickLoadCards.has(opportunity.OpportunityIterationsID) && (
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#ffffff80',
                          zIndex: 10,
                        }}
                      >
                        <ProgressSpinner
                          style={{ width: '30px', height: '30px' }}
                          strokeWidth="8"
                          fill="var(--surface-ground)"
                          animationDuration=".5s"
                        />
                      </div>
                    )}
                    <span>{opportunity.IterationCounter ? opportunity.IterationCounter : '-'}</span>
                    <span
                      className={styles.moleculeField}
                      onMouseOver={e => (e.currentTarget.style.textDecoration = 'underline')}
                      onMouseOut={e => (e.currentTarget.style.textDecoration = 'none')}
                      onClick={() => {
                        handleCardClick(
                          opportunity.OpportunityIterationsID,
                          opportunity.OpportunityID
                        );
                      }}
                    >
                      {opportunity.MoleculeAndForm}
                    </span>
                    <div>{source}</div>
                    <div className={styles.dropdown}>
                      <Dropdown
                        options={boardDetails?.[board]?.Stage}
                        optionLabel="Stage"
                        optionValue="ID"
                        value={opportunity.StageID}
                        onChange={e =>
                          handleDropdownChange(
                            opportunity.OpportunityIterationsID,
                            'Stage',
                            e.value
                          )
                        }
                        placeholder="Unassigned"
                        className={styles.selectDropdown}
                        disabled={
                          !checkIfFunctionalityEnabled(
                            bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                            userModulesRoles.opptracker,
                            userModulesRoles
                          )
                        }
                      />
                    </div>
                    <div className={styles.dropdown}>
                      <Dropdown
                        options={getStatus(
                          opportunity.StageID,
                          boardDetails?.[board]?.Status || []
                        )}
                        optionLabel="Status"
                        optionValue="ID"
                        value={opportunity.StatusID}
                        onChange={e =>
                          handleDropdownChange(
                            opportunity.OpportunityIterationsID,
                            'Status',
                            e.value
                          )
                        }
                        placeholder="Unassigned"
                        className={styles.selectDropdown}
                        style={{
                          width: '9rem',
                          backgroundColor:
                            (opportunity.StatusID === 1 && opportunity.StageID !== 8) ||
                            (opportunity.StageID === 8 && opportunity.StatusID === 5)
                              ? '#ffcccc'
                              : opportunity.StatusID === 2 ||
                                  (opportunity.StageID === 8 && opportunity.StatusID === 1)
                                ? '#fff4cc'
                                : opportunity.StatusID === 3 || opportunity.StatusID === 4
                                  ? '#d4f8cc'
                                  : 'white',
                          border:
                            (opportunity.StatusID === 1 && opportunity.StageID !== 8) ||
                            (opportunity.StageID === 8 && opportunity.StatusID === 5)
                              ? '1px solid #a80000'
                              : opportunity.StatusID === 2 ||
                                  (opportunity.StageID === 8 && opportunity.StatusID === 1)
                                ? '1px solid #b38b00'
                                : opportunity.StatusID === 3 || opportunity.StatusID === 4
                                  ? '1px solid #006400'
                                  : '1px solid transparent',
                        }}
                        pt={{
                          input: {
                            style: {
                              color:
                                (opportunity.StatusID === 1 && opportunity.StageID !== 8) ||
                                (opportunity.StageID === 8 && opportunity.StatusID === 5)
                                  ? '#a80000'
                                  : opportunity.StatusID === 2 ||
                                      (opportunity.StageID === 8 && opportunity.StatusID === 1)
                                    ? '#b38b00'
                                    : opportunity.StatusID === 3 || opportunity.StatusID === 4
                                      ? '#006400'
                                      : 'black',
                            },
                          },
                          trigger: {
                            style: {
                              color:
                                (opportunity.StatusID === 1 && opportunity.StageID !== 8) ||
                                (opportunity.StageID === 8 && opportunity.StatusID === 5)
                                  ? '#a80000'
                                  : opportunity.StatusID === 2 ||
                                      (opportunity.StageID === 8 && opportunity.StatusID === 1)
                                    ? '#b38b00'
                                    : opportunity.StatusID === 3 || opportunity.StatusID === 4
                                      ? '#006400'
                                      : 'black',
                            },
                          },
                        }}
                        disabled={
                          !checkIfFunctionalityEnabled(
                            bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                            userModulesRoles.opptracker,
                            userModulesRoles
                          )
                        }
                      />
                    </div>
                    <div className={styles.dropdown}>
                      <Dropdown
                        options={boardDetails?.[board]?.User}
                        optionLabel="Name"
                        optionValue="ID"
                        value={opportunity.AnalystID}
                        onChange={e =>
                          handleDropdownChange(
                            opportunity.OpportunityIterationsID,
                            'Analyst',
                            e.value
                          )
                        }
                        placeholder="Unassigned"
                        className={styles.selectDropdown}
                        disabled={
                          !checkIfFunctionalityEnabled(
                            bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                            userModulesRoles.opptracker,
                            userModulesRoles
                          )
                        }
                        itemTemplate={assigneeOptionTemplate}
                        valueTemplate={assigneeOptionTemplate}
                      />
                    </div>
                  </div>
                );
              }
            )}
          {isEditOpportunityModalOpen && opportunityIID && (
            <EditOpportunity
              visible={isEditOpportunityModalOpen}
              closeModal={closeEditOpportunityModal}
              viewType={'List'}
              opportunityIterationID={opportunityIID}
              opportunityID={opportunityID!}
            />
          )}
        </div>
      ) : !quickLoad ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            padding: '1rem',
          }}
        >
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
        </div>
      ) : null}
    </>
  );
};

export default observer(MultiKanbanList);
